export default {
  install: function (Vue) {
    Vue.prototype.companyType = ['未知', '外商独资公司', '合资公司', '国有企业', '民营公司', '上市公司'],
    Vue.prototype.companySize = ['未知', '1-10人', '11-50人', '51-100人', '101-500人', '501-1000人',
    '1001-5000人', '5001-10000人', '多于10001人'],
    Vue.prototype.blogCategory = [
      {"id": 1, "c_name": "职场建议", "e_name": "Career Advices", "cn": "badge bg-g" },
      {"id": 2, "c_name": "行业资讯", "e_name": "Industry News", "cn": "badge bg-a" },
      {"id": 3, "c_name": "新闻大爆炸", "e_name": "Breaking News", "cn": "badge bg-d"},
      {"id": 4, "c_name": "成功案例", "e_name": "Successful Cases", "cn": "badge bg-l"},
      {"id": 5, "c_name": "ER Family", "e_name": "ER Family", "cn": "badge bg-o"},
      {"id": 6, "c_name": "顾问风采", "e_name": "Star Consultants", "cn": "badge bg-y"},
      {"id": 7, "c_name": "其他", "e_name": "Others", "cn": "badge bg-s"}
    ],
    Vue.prototype.salaryRange = [
      { "id": "rn_100000", "c_fullname": "10万以下", "e_fullname": "Below 100K" },
      { "id": "r100000_200000", "c_fullname": "10-20万", "e_fullname": "100-200K" },
      { "id": "r200000_300000", "c_fullname": "20-30万", "e_fullname": "200-300K" },
      { "id": "r300000_500000", "c_fullname": "30-50万", "e_fullname": "300-500K" },
      { "id": "r500000_1000000", "c_fullname": "50-100万", "e_fullname": "500-1000K" },
      { "id": "r1000000_n", "c_fullname": "100万以上", "e_fullname": "Above 1000K" }
  ],
  Vue.prototype.openDate = [
      { "id": "now-3d", "c_fullname": "3天内", "e_fullname": "3天内" },
      { "id": "now-1w", "c_fullname": "1周内", "e_fullname": "1周内" },
      { "id": "now-1M", "c_fullname": "1个月内", "e_fullname": "1个月内" }
  ],
  Vue.prototype.workLength = [
    { "id": "not_required", "c_fullname": "不限", "e_fullname": "Not required"},
    { "id": "not_required_graduates", "c_fullname": "不限, 应届生", "e_fullname": "Not required, Undergraduates"},
      { "id": "graduates", "c_fullname": "应届生", "e_fullname": "Undergraduates"},
      { "id": "one_to_three", "c_fullname": "1-3年", "e_fullname": "1-3 years"},
      { "id": "three_to_five", "c_fullname": "3-5年", "e_fullname": "3-5 years"},
      { "id": "five_to_ten", "c_fullname": "5-10年", "e_fullname": "5-10 years"},
      { "id": "gt_ten", "c_fullname": "10年以上", "e_fullname": "Above 10 years"}
  ],
  Vue.prototype.jobType = [
      { "id": "permanent", "c_fullname": "全职", "e_fullname": "Fulltime"},
      { "id": "parttime", "c_fullname": "兼职", "e_fullname": "Parttime"},
      { "id": "intern", "c_fullname": "实习", "e_fullname": "Intern"},
      { "id": "temp", "c_fullname": "临时", "e_fullname": "Temp"}
  ],
  Vue.prototype.featuredJob = [
      { "id": "1", "c_fullname": "认可雇主职位", "e_fullname": "Featured Jobs"}
  ],
  Vue.prototype.hotCities = [
      { "id": "11", "name": "北京", "e_fullname": "Beijing"},
      { "id": "2", "name": "上海", "e_fullname": "Shanghai"},
      { "id": "31", "name": "广州", "e_fullname": "Guangzhou"},
      { "id": "36", "name": "深圳", "e_fullname": "Shenzhen"},
      { "id": "218", "name": "武汉", "e_fullname": "Wuhan"},
      { "id": "251", "name": "西安", "e_fullname": "Xi'an"},
      { "id": "106", "name": "杭州", "e_fullname": "Hangzhou"},
      { "id": "91", "name": "南京", "e_fullname": "Nanjing"},
      { "id": "53", "name": "成都", "e_fullname": "Chengdu"},
      { "id": "28", "name": "重庆", "e_fullname": "Chongqing"},
      { "id": "47", "name": "东莞", "e_fullname": "Dongguan"},
      { "id": "274", "name": "大连", "e_fullname": "Dalian"},
      { "id": "272", "name": "沈阳", "e_fullname": "Shenyang"},
      { "id": "94", "name": "苏州", "e_fullname": "Suzhou"},
      { "id": "118", "name": "昆明", "e_fullname": "Kunming"},
      { "id": "77", "name": "长沙", "e_fullname": "Changsha"},
      { "id": "158", "name": "合肥", "e_fullname": "Hefei"},
      { "id": "109", "name": "宁波", "e_fullname": "Ningbo"},
      { "id": "234", "name": "郑州", "e_fullname": "Zhengzhou"},
      { "id": "21", "name": "天津", "e_fullname": "Tianjin"},
      { "id": "348", "name": "青岛", "e_fullname": "Qingdao"},
      { "id": "347", "name": "济南", "e_fullname": "Jinan"},
      { "id": "300", "name": "哈尔滨", "e_fullname": "Harbin"},
    { "id": "174", "name": "长春", "e_fullname": "Changchun"},
    { "id": "310", "name": "福州", "e_fullname": "Fuzhou"}
  ],
  Vue.prototype.hkMcTw = [
      { "id": "369", "name": "香港", "e_fullname": "Hong Kong"},
      { "id": "370", "name": "澳门", "e_fullname": "Macau"},
      { "id": "371", "name": "台湾", "e_fullname": "Taiwan"}
  ],
  Vue.prototype.getBlogCategory = function(id) {
        if (id === 0) return 'None'
        let t = this.blogCategory.find(function(obj) {
            return obj.id === id
        })
        return this.$i18n.locale === 'zh' ? t['c_name'] : t['e_name']
    },
    Vue.prototype.getBlogCategoryClass = function(id) {
        if (id === 0) return 'None'
        let t = this.blogCategory.find(function(obj) {
            return obj.id === id
        })
        return t['cn']
    },
  Vue.prototype.parseExpQuery = function(exps) {
    if (exps.length > 1 || exps[0] !== 'graduates') {
      // For any selected item other than graduates, add "not required"
      exps.push('not_required');
      exps.push('not_required_graduates');
      var graduates = exps.indexOf('graduates');
      if (graduates > -1) {
        exps.splice(graduates, 1);
        exps.push('zero');
      }
    } else {
      // The only selected item is graduates
      exps = ['zero', 'not_required_graduates'];
    }
    return {
      filter: {
        type: 'must',
        filter: {
          terms: { required_experience: exps }
        }
      }
    };
  },
    Vue.prototype.parseSalaryQuery = function(salary) {
    let rangeFilters = [],
        s = salary

    if(typeof salary === 'string') {
      s = []
      s.push(salary)
    }
    s.forEach(function(value, index, array) {
      var range = value.replace('r', '').split('_'),
          filter = [];
      if (range[0] !== 'n')
        filter.push({ range: { 'salary_to.amount': { gte: range[0] }}});
      if (range[1] !== 'n')
        filter.push({ range: { 'salary_from.amount': { lte: range[1] }}});
      rangeFilters.push(filter.length > 1 ? { and: filter } : filter[0]);
    });
    return {
      filter: {
        type: 'must',
        filter: {
          and: [{
            term: {
              'salary_from.unit': 'per_year'
            }
          }, {
            or: rangeFilters
          }]
        }
      }
    };
  },
  Vue.prototype.normalizeName = function(o) {
    if (!o || typeof o !== 'object' || o.name) return;
    if (this.$i18n.locale === 'zh') {
      o.name = o.c_name || o.e_name || '';
      o.fullName = o.c_fullname || o.e_fullname || '';
    } else {
      o.name = o.e_name || o.c_name || '';
      o.fullName = o.e_fullname || o.c_fullname || '';
    }
    return o;
  },
  Vue.prototype.normalizeCompany = function(o) {
        if (!o || typeof o !== 'object' || o.name) return;
        if (this.$i18n.locale === 'zh') {
          o.name = o.c_name || o.e_name || '';
        } else {
          o.name = o.e_name || o.c_name || '';
        }
        return o;
  },
  Vue.prototype.jobTypeLabel = function(type) {
    let t = this.$t('jobs.permanent')
    switch(type) {
      case 'temp':
        t = this.$t('jobs.temp')
        break
      case 'intern':
        t = this.$t('jobs.intern')
        break
      case 'parttime':
        t = this.$t('jobs.parttime')
    }
    return t
  },
  Vue.prototype.expLabel = function(exp) {
    let t = '' 
    switch(exp) {
      case 'zero':
        t = this.$t('jobs.graduates')
        break
      case 'one_to_three':
        t = this.$t('jobs.one_to_three')
        break
      case 'three_to_five':
        t = this.$t('jobs.three_to_five')
        break
      case 'five_to_ten':
        t = this.$t('jobs.five_to_ten')
        break
      case 'gt_ten':
        t = this.$t('jobs.gt_ten')
        break
      case 'not_required':
        t = this.$t('jobs.not_required')
        break
      case 'not_required_graduates':
        t = this.$t('jobs.not_required_graduates')
    }
    return t
  },
  Vue.prototype.salaryLabel = function(from, to, negotiable) {
    if (negotiable)
      return this.$t('utils.negotiable');
    var unit = from && from.unit || to && to.unit;
    from = from && typeof from === 'object' ? from.amount : from;
    to =  to && typeof to === 'object' ? to.amount : to;
    var calcUnit = this.$i18n.locale === 'zh' ? 10 : 1;

    if (!from && to) from = to;
    if (from && !to) to = from;

    var unitLabel = this.$i18n.locale === 'zh' ? '元/天' : '/day';
    if (unit === 'per_year') {
      // Make accuracy up to k for yearly salary
      from = Math.round(from / 1000) / calcUnit;
      to = Math.round(to / 1000) / calcUnit;
      unitLabel = this.$i18n.locale === 'zh' ? '万/年' : 'K/year';
    } else if (unit === 'per_month') {
      // Make accuracy up to 0.1k for monthly salary
      from = Math.round(from / 100) / calcUnit;
      to = Math.round(to / 100) / calcUnit;
      unitLabel = this.$i18n.locale === 'zh' ? '千/月' : 'K/month';
      if (from >= 10 || to >= 10) {
        from = from * 10 / 100;
        to = to * 10 / 100;
        unitLabel = this.$i18n.locale === 'zh' ? '万/月' : 'K/month';
      }
    }
    if (from === to)
      return from + unitLabel;
    return '¥ ' + from + '-' + to + unitLabel;
  },
  Vue.prototype.applyStatus = function(status) {
      if (status == 'initial') return '已投递'
      else if (status == 'viewed') return '已查阅'
      else if (status == 'screened') return '已初筛'
      else if (status == 'recommended') return '已推荐'
      else if (status == 'interview') return '面试中'
      else if (status == 'onboard') return '已入职'
      else if (status == 'pass_probation') return '已转正'
      else if (status == 'out') return '不合适'
    },
  Vue.prototype.itemize = function(value) {
    let i = '<ul class="detail-list">';
    if (value && value.trim() !== '') {
      value.split(/[\n]/).forEach(function(item) {
        if (item.trim() !== '')
          i += '<li>' + item + '</li>';
      });
      return i + '</ul>';
    } else {
      return '';
    }
  },
  Vue.prototype.isMobile = function() {
      return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    }
  }
};